import { __extends } from "tslib";
import { Filter3DCopyPixelTask } from './tasks/Filter3DCopyPixelTask';
import { Filter3DCopyPixelTaskWebGL } from './tasks/webgl/Filter3DCopyPixelTaskWebgGL';
import { Filter3DBase } from './Filter3DBase';
import { ContextWebGL } from '../webgl/ContextWebGL';
var CopyPixelFilter3D = /** @class */ (function (_super) {
    __extends(CopyPixelFilter3D, _super);
    function CopyPixelFilter3D() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new CopyPixelFilter3D object
     */
    CopyPixelFilter3D.prototype.init = function (context) {
        if (this._context === context) {
            return;
        }
        _super.prototype.init.call(this, context);
        this._copyPixelTask = context instanceof ContextWebGL
            ? new Filter3DCopyPixelTaskWebGL()
            : new Filter3DCopyPixelTask();
        this.addTask(this._copyPixelTask);
    };
    Object.defineProperty(CopyPixelFilter3D.prototype, "colorTransform", {
        get: function () {
            return this._copyPixelTask.transform;
        },
        set: function (value) {
            this._copyPixelTask.transform = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CopyPixelFilter3D.prototype, "rect", {
        get: function () {
            return this._copyPixelTask.rect;
        },
        set: function (value) {
            this._copyPixelTask.rect = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CopyPixelFilter3D.prototype, "destPoint", {
        get: function () {
            return this._copyPixelTask.destPoint;
        },
        set: function (value) {
            this._copyPixelTask.destPoint = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CopyPixelFilter3D.prototype, "sourceTexture", {
        get: function () {
            return this._copyPixelTask.sourceTexture;
        },
        set: function (value) {
            this._copyPixelTask.sourceTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    return CopyPixelFilter3D;
}(Filter3DBase));
export { CopyPixelFilter3D };
